// This is just an example,
// so you can safely delete all default props below

export default {
    signin_title: 'Logg inn',
    signin_desc: 'Logg inn på båtbestillingsløsningen.<br/>- Pålogging til MinSide på kolumbus.no kan ikke brukes her.<br/>- Brukerkonto/pålogging til båtbestillingsløsningen er valgfritt å ha/bruke for å kjøpe/reservere båtbilletter.',
    signin: 'Logg inn',
    signup: 'Opprett bruker',
    email: 'E-post',
    password: 'Passord',
    stay_signed_in: 'Forbli innlogget?',
    forget_password: 'Glemt passord?',
    error_email: 'E-post er ikke gyldig',
    error_password: 'Passord må oppgis',
    error_sign_in: 'E-post og passordkombinasjonen er ikke korrekt'
}